import { useBreak } from "hooks/useBreak"
import { Label } from "./Overview.label"
import { _bootstrap } from "state/store.bootstrap"
import { getFocus, useAtom, useGet } from "state/jotai"
import { current_language, rotate_by_slider } from "state/store.global"
import { AnimatePresence } from "framer-motion"
import { motion } from 'framer-motion'
import { MobileLabel } from "./MobileOverview.label"
import { _project } from "state/store.projects"

export const Overview = ({ index, rmode, status, showLabel, setShowLabel, hoveredId }) => {

  
    const labelOptions = getFocus(_bootstrap, 'projectnames')
   
    const currentLanguage = useAtom(current_language)[0];

    const isRotate_Done = useGet(rotate_by_slider)
    const isDesktop     = useBreak('md_up')
    
    const L = [ // desktop labels position
        {L1: [1690, 870] , L2: [2010, 690] ,L3:[1784,600],L4:[1539,557]},
        { L1: [1950, 560] , L2: [1550, 490],L3:[1399,548],L4:[1226,624] },
        { L1: [1150, 600] , L2: [880, 760],L3:[1152,772],L4:[1357,853] },
        {  L1: [1090, 800] , L2: [1500, 950], L3:[1693,823],L4:[1880,734] },
       {L1: [1690, 900] , L2: [2010, 720], L3:[1734,626],L4:[1507,556] },
    ];

    const circle = [ // desktop circle position
        { L1: [50, 300]  , L2: [50, 300] ,L3:[50,300],L4:[50,300]}, 
        {  L1: [50, 300] ,  L2: [50, 300], L3:[50,300],L4:[50,300]},
        { L1: [50, 300] , L2: [50, 300], L3:[50,300],L4:[50,300]}, 
        { L1: [50, 300] ,L2: [50, 300], L3:[50,300],L4:[50,300] },
        { L1: [50, 300], L2: [50, 300], L3:[50,300],L4:[50,300] },
    ]
    const mobileL = [ // mobile labels position
        { L1: [1700, 800] , L2: [1980, 640], L3:[1747,560],L4:[1531,481]},
        { L1: [1900, 500] , L2: [1580, 390], L3:[1420,530],L4:[1200,600]},
        { L1: [1150, 570] , L2: [900, 700], L3:[1165,728],L4:[1353,793]},
        { L1: [1100, 750]  ,L2: [1510, 860], L3:[1696,781],L4:[1870,676] },
        { L1: [1700, 800] , L2: [1980, 640], L3:[1760,580],L4:[1537,495]},
    ];

    const mobileLine = [ // mobile line lengths
        { L2: [450, 0] },
        { L2: [400, 0] },
        { L2: [550, 0] },
        { L2: [500, 0] },
        { L2: [450, 0] },
    ];

    const mobileLineAngle = [ // mobile line angles
        { L2: 215 },
        { L2: 285 },
        { L2: 85 },
        { L2: -285 },
        { L2: 215 },
    ];

    const mobileLabelAxis = [ // mobile label positions
        { L1:[0, 0] , L2:[0, 0] ,L3:[0, 0],L4:[0, 0]},
        { L1:[0, 0] , L2:[0, 0] ,L3:[0, 0],L4:[0, 0]},
        { L1:[0, 0] , L2:[0, 0] ,L3:[0, 0],L4:[0, 0]},
        { L1:[0, 0] , L2:[0, 0] ,L3:[0, 0],L4:[0, 0]},
        { L1:[0, 0] , L2:[0, 0] ,L3:[0, 0],L4:[0, 0]},
    ];

    const animation = {
        initial   : { opacity: 0 },
        animate   : { opacity: 1 },
        exit      : { opacity: 0 },
        transition: { duration: 0.1, ease: 'linear' },
    }

    return (
        <AnimatePresence>
            {
                
                status === 'DONE' && isRotate_Done &&
                <>
                    {
                     
                        isDesktop ?
                        labelOptions?.[currentLanguage]?.map((label, i) => {
                            if (L?.[index]?.[`L${i}`]) {
                               
                                if (i) {
                                    return (
                                        
                                        <motion.div {...animation} key = {i}>
                                        <Label      setShowLabel       = {setShowLabel} c = {L?.[index]?.[`L${i}`]} sc = {1} d = {40} l = {0} r = {circle?.[index]?.[`L${i}`]} {...{ rmode }} labelsInfo = {label} showLabel = {showLabel} hoveredId = {hoveredId}/>
                                        </motion.div>
                                    )
                                }
                                return null;
                                }
                            })
                            : 
                            labelOptions?.[currentLanguage]?.map((label, i) => {
                              
                                if (i) {
                                    return (
                                        <motion.div  {...animation} key = {i}>
                                        <MobileLabel setShowLabel       = {setShowLabel} c = {mobileL?.[index]?.[`L${i}`]} sc = {1} d = {40} l = {0} r = {circle?.[index]?.[`L${i}`]} {...{ rmode }} labelsInfo = {label} line = {mobileLine?.[index]?.[`L${i}`]} angle = {mobileLineAngle?.[index]?.[`L${i}`]} mobileLabelAxis = {mobileLabelAxis?.[index]?.[`L${i}`]} showLabel = {showLabel} hoveredId = {hoveredId}/>
                                        </motion.div>
                                    )
                                }
                                return null;
                              
                            })
                    }
                </>
            }
        </AnimatePresence>
    )
}
